import { cloneDeep, every } from 'lodash-es';
import { Customer, MarketingPreference } from '../client/src';
import { EMPTY_CUSTOMER } from '@nx-ng/constants';
import { ICustomerDetailsPage } from '@nx-ng/types';

export const formatCustomerForUI = (
  customer: Customer | undefined
): ICustomerDetailsPage => {
  const newCustomer: Customer = customer
    ? cloneDeep({ ...customer })
    : EMPTY_CUSTOMER;

  return {
    customerDetails: {
      ...newCustomer,
      dateOfBirth: newCustomer.dateOfBirth
        ? new Date(newCustomer.dateOfBirth)
        : undefined,
      address: {
        ...newCustomer.address,
      },
    },

    preferences: {
      keepInTouch: determineKeepinTouch(newCustomer.marketingPreferences),
    },
  };
};

export const determineKeepinTouch = (
  marketingPreferences: MarketingPreference[] | undefined
): boolean | undefined => {
  if (!marketingPreferences || marketingPreferences.length === 0) {
    return undefined;
  }
  if (
    every(
      marketingPreferences,
      (preference: MarketingPreference) => preference.optIn === false
    )
  ) {
    return false;
  }
  return true;
};
